import * as React from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import { styled } from '@mui/material/styles';

export type DigitalStylingTableHeaderLabels = {
    orderNumber: string;
    broker: string;
    product: string;
    address: string;
    orderStatus: string;
    createdAt: string;
    photoTime: string;
    assignedUser: string;
};

type DigitalStylingTableHeaderProps = {
    labels: DigitalStylingTableHeaderLabels;
};

let StyledTableCell = styled(TableCell)(() => ({
    fontSize: '18px'
}));

export function DigitalStylingTableHeader({ labels }: DigitalStylingTableHeaderProps) {
    return (
        <TableHead>
            <TableRow>
                <StyledTableCell>{labels.orderNumber}</StyledTableCell>
                <StyledTableCell>{labels.broker}</StyledTableCell>
                <StyledTableCell>{labels.product}</StyledTableCell>
                <StyledTableCell>{labels.address}</StyledTableCell>
                <StyledTableCell>{labels.orderStatus}</StyledTableCell>
                <StyledTableCell>{labels.createdAt}</StyledTableCell>
                <StyledTableCell>{labels.photoTime}</StyledTableCell>
                <StyledTableCell>{labels.assignedUser}</StyledTableCell>
            </TableRow>
        </TableHead>
    );
}
